
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M22.488 30.108c2.056-2.06 2.309-5.354.607-7.884l1.822-1.822 1.82 1.82 1.733-1.734-1.82-1.82 1.734-1.733 2.729 2.73 1.734-1.734-2.73-2.73.867-.866-1.819-1.82-7.89 7.89c-2.53-1.702-5.822-1.449-7.883.607-2.39 2.39-2.294 6.374.214 8.882s6.492 2.604 8.882.214zm-7.277-7.277c1.433-1.433 3.825-1.376 5.33.129 1.504 1.504 1.561 3.896.128 5.33-1.434 1.433-3.825 1.375-5.33-.13-1.504-1.504-1.562-3.895-.128-5.329z","fill":"#000"}}),_c('path',{attrs:{"d":"M.787 22L22 .788l21.213 21.214L22 43.214z"}})])])
          )
        }
      }
    